module.exports = __webpack_public_path__ + "static/media/Fitness-Banner.4b8d9639.jpg";